var SV_ES = ((document.documentElement && document.documentElement.lang) || '').slice(0, 2) === 'es';
(function () {
  if (window.SV_PRODUCT_CARD_LOADED) return;
  window.SV_PRODUCT_CARD_LOADED = true;

  var currency = window.SV_PRODUCT_CARD_CURRENCY || 'EUR';
  var ACTIVE_MODAL_CLASS = 'is-open';

  function formatMoney(cents) {
    var amount = Number(cents || 0) / 100;

    try {
      return new Intl.NumberFormat('es-ES', {
        style: 'currency',
        currency: currency,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(amount);
    } catch (error) {
      return amount.toFixed(2).replace('.', ',') + ' €';
    }
  }

  function calculatePackTotal(unitPriceCents, packSize, discountPercent) {
    var fullTotal = Number(unitPriceCents || 0) * Number(packSize || 1);
    var discountMultiplier = 100 - Number(discountPercent || 0);

    return Math.round(fullTotal * discountMultiplier / 100);
  }

  function getCardFromElement(element) {
    if (!element) return null;
    return element.closest('[data-sv-pack-card]');
  }

  function getStockModal(card) {
    if (!card) return null;

    return (
      card.querySelector('[data-sv-back-stock-modal]') ||
      card.querySelector('[data-sv-stock-modal]') ||
      card.querySelector('[data-sv-out-of-stock-modal]') ||
      card.querySelector('.sv-back-stock-modal') ||
      card.querySelector('.sv-stock-modal') ||
      card.querySelector('.sv-out-of-stock-modal')
    );
  }

  function getStockOverlay(card) {
    if (!card) return null;

    return (
      card.querySelector('[data-sv-back-stock-overlay]') ||
      card.querySelector('[data-sv-stock-modal-overlay]') ||
      card.querySelector('[data-sv-out-of-stock-modal-overlay]') ||
      card.querySelector('.sv-back-stock-overlay') ||
      card.querySelector('.sv-stock-modal__overlay') ||
      card.querySelector('.sv-out-of-stock-modal__overlay')
    );
  }

  function openStockModal(card) {
    var modal = getStockModal(card);
    if (!modal) return false;

    var overlay = getStockOverlay(card);

    modal.hidden = false;
    modal.classList.add(ACTIVE_MODAL_CLASS);
    modal.setAttribute('aria-hidden', 'false');

    if (overlay) {
      overlay.hidden = false;
      overlay.classList.add(ACTIVE_MODAL_CLASS);
      overlay.setAttribute('aria-hidden', 'false');
    }

    document.documentElement.setAttribute('data-sv-modal-open', 'true');

    var firstInput = modal.querySelector('input[type="email"], input, textarea, select, button, a[href]');
    if (firstInput) {
      window.setTimeout(function () {
        firstInput.focus({ preventScroll: true });
      }, 80);
    }

    return true;
  }

  function closeStockModal(modal) {
    if (!modal) return;

    var card = getCardFromElement(modal);
    var overlay = getStockOverlay(card);

    modal.classList.remove(ACTIVE_MODAL_CLASS);
    modal.setAttribute('aria-hidden', 'true');

    if (overlay) {
      overlay.classList.remove(ACTIVE_MODAL_CLASS);
      overlay.setAttribute('aria-hidden', 'true');
    }

    document.documentElement.removeAttribute('data-sv-modal-open');

    window.setTimeout(function () {
      if (!modal.classList.contains(ACTIVE_MODAL_CLASS)) {
        modal.hidden = true;
      }

      if (overlay && !overlay.classList.contains(ACTIVE_MODAL_CLASS)) {
        overlay.hidden = true;
      }
    }, 220);
  }

  function closeAllStockModals() {
    var modals = document.querySelectorAll(
      '[data-sv-back-stock-modal], [data-sv-stock-modal], [data-sv-out-of-stock-modal], .sv-back-stock-modal, .sv-stock-modal, .sv-out-of-stock-modal'
    );

    modals.forEach(function (modal) {
      closeStockModal(modal);
    });
  }

  function selectPack(card, button) {
    if (!card || !button) return;

    var packButtons = card.querySelectorAll('[data-sv-pack-button]');
    var priceElement = card.querySelector('[data-sv-card-price]');
    var unitPriceElement = card.querySelector('[data-sv-card-unit-price]');
    var variantInput = card.querySelector('[data-sv-variant-input]');
    var quantityInput = card.querySelector('[data-sv-quantity-input]');
    var addButton = card.querySelector('[data-sv-add]');
    var stockAlertButton =
      card.querySelector('[data-sv-stock-alert-link]') ||
      card.querySelector('[data-sv-stock-alert]') ||
      card.querySelector('[data-sv-open-stock-modal]') ||
      card.querySelector('[data-sv-back-in-stock]') ||
      card.querySelector('.sv-stock-alert-link') ||
      card.querySelector('.sv-back-in-stock');

    var packSize = Number(button.dataset.packSize || 1);
    var quantity = Number(button.dataset.quantity || packSize || 1);
    var unitPriceCents = Number(button.dataset.unitPriceCents || 0);
    var discountPercent = Number(button.dataset.discountPercent || 0);
    var isAvailable = button.dataset.available === 'true';

    var packTotal = calculatePackTotal(unitPriceCents, packSize, discountPercent);
    var packUnitPrice = Math.round(packTotal / packSize);

    packButtons.forEach(function (item) {
      var isActive = item === button;
      item.classList.toggle('is-active', isActive);
      item.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });

    if (priceElement) {
      priceElement.textContent = formatMoney(packTotal);
    }

    if (unitPriceElement) {
      unitPriceElement.textContent = formatMoney(packUnitPrice) + (SV_ES ? ' /lata' : ' /can');
    }

    if (variantInput) {
      variantInput.value = button.dataset.variantId || variantInput.value;
    }

    if (quantityInput) {
      quantityInput.value = quantity;
    }

    if (addButton) {
      addButton.dataset.currentAvailable = isAvailable ? 'true' : 'false';
      addButton.type = isAvailable ? 'submit' : 'button';
      addButton.textContent = isAvailable ? (SV_ES ? 'Añadir al carrito' : 'Add to cart') : (SV_ES ? 'Agotado' : 'Sold out');
      addButton.classList.toggle('is-sold-out', !isAvailable);
      addButton.classList.remove('is-added');
    }

    if (stockAlertButton) {
      stockAlertButton.hidden = isAvailable;
      stockAlertButton.classList.toggle('is-hidden', isAvailable);
      stockAlertButton.setAttribute('aria-hidden', isAvailable ? 'true' : 'false');
    }
  }

  function initCards(root) {
    var scope = root || document;
    var cards = scope.querySelectorAll('[data-sv-pack-card]:not([data-sv-initialized])');

    cards.forEach(function (card) {
      card.setAttribute('data-sv-initialized', 'true');

      var preferredButton =
        card.querySelector('[data-sv-pack-button][data-pack-size="1"][data-available="true"]') ||
        card.querySelector('[data-sv-pack-button][data-available="true"]') ||
        card.querySelector('[data-sv-pack-button]');

      if (preferredButton) {
        selectPack(card, preferredButton);
      }

      var modals = card.querySelectorAll(
        '[data-sv-back-stock-modal], [data-sv-stock-modal], [data-sv-out-of-stock-modal], .sv-back-stock-modal, .sv-stock-modal, .sv-out-of-stock-modal'
      );

      modals.forEach(function (modal) {
        if (!modal.classList.contains(ACTIVE_MODAL_CLASS)) {
          modal.hidden = true;
          modal.setAttribute('aria-hidden', 'true');
        }
      });

      var overlays = card.querySelectorAll(
        '[data-sv-back-stock-overlay], [data-sv-stock-modal-overlay], [data-sv-out-of-stock-modal-overlay], .sv-back-stock-overlay, .sv-stock-modal__overlay, .sv-out-of-stock-modal__overlay'
      );

      overlays.forEach(function (overlay) {
        if (!overlay.classList.contains(ACTIVE_MODAL_CLASS)) {
          overlay.hidden = true;
          overlay.setAttribute('aria-hidden', 'true');
        }
      });
    });
  }

  window.SV_INIT_PRODUCT_CARDS = initCards;
  window.SV_OPEN_STOCK_MODAL = openStockModal;
  window.SV_CLOSE_STOCK_MODAL = closeStockModal;

  document.addEventListener('click', function (event) {
    var packButton = event.target.closest('[data-sv-pack-button]');

    if (packButton) {
      event.preventDefault();
      event.stopPropagation();

      var packCard = getCardFromElement(packButton);
      selectPack(packCard, packButton);
      return;
    }

    var stockTrigger = event.target.closest(
      '[data-sv-stock-alert-link], [data-sv-stock-alert], [data-sv-open-stock-modal], [data-sv-back-in-stock], .sv-stock-alert-link, .sv-back-in-stock'
    );

    if (stockTrigger) {
      event.preventDefault();
      event.stopPropagation();

      openStockModal(getCardFromElement(stockTrigger));
      return;
    }

    var addButton = event.target.closest('[data-sv-add]');

    if (addButton && addButton.dataset.currentAvailable === 'false') {
      event.preventDefault();
      event.stopPropagation();

      openStockModal(getCardFromElement(addButton));
      return;
    }

    var closeButton = event.target.closest(
      '[data-sv-back-stock-close], [data-sv-stock-modal-close], [data-sv-stock-close], .sv-back-stock-close, .sv-stock-modal__close, .sv-out-of-stock-modal__close'
    );

    if (closeButton) {
      event.preventDefault();
      event.stopPropagation();

      var modalToClose = closeButton.closest(
        '[data-sv-back-stock-modal], [data-sv-stock-modal], [data-sv-out-of-stock-modal], .sv-back-stock-modal, .sv-stock-modal, .sv-out-of-stock-modal'
      );

      closeStockModal(modalToClose);
      return;
    }

    var overlay = event.target.closest(
      '[data-sv-back-stock-overlay], [data-sv-stock-modal-overlay], [data-sv-out-of-stock-modal-overlay], .sv-back-stock-overlay, .sv-stock-modal__overlay, .sv-out-of-stock-modal__overlay'
    );

    if (overlay) {
      event.preventDefault();
      event.stopPropagation();

      var overlayCard = getCardFromElement(overlay);
      var overlayModal = getStockModal(overlayCard);

      closeStockModal(overlayModal);
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      closeAllStockModals();
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initCards(document);
    });
  } else {
    initCards(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initCards(event.target);
  });

  var observer = new MutationObserver(function () {
    initCards(document);
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();